import request from '@/utils/request'
export function updateOne(data) {
  return request({
    url: '/icps/system/sign/basicsterrace/introduce/updateOne',
    method: 'post',
    data
  })
}
export function queryOne() {
  return request({
    url: '/icps/system/sign/basicsterrace/introduce/queryOne',
    method: 'get'
  })
}